/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_EnterInputs */

const th_event_enter = /** @type {(inputs: Event_EnterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สมัคร`)
};

const en_event_enter = /** @type {(inputs: Event_EnterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter`)
};

const ja_event_enter = /** @type {(inputs: Event_EnterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`申し込む`)
};

const zh_event_enter = /** @type {(inputs: Event_EnterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`报名`)
};

const es_event_enter = /** @type {(inputs: Event_EnterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inscribir`)
};

const pt_event_enter = /** @type {(inputs: Event_EnterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inscrever`)
};

const id_event_enter = /** @type {(inputs: Event_EnterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daftar`)
};

const fr_event_enter = /** @type {(inputs: Event_EnterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inscrire`)
};

const tl_event_enter = /** @type {(inputs: Event_EnterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sumali`)
};

const vi_event_enter = /** @type {(inputs: Event_EnterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đăng ký`)
};

const ko_event_enter = /** @type {(inputs: Event_EnterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`참가`)
};

const de_event_enter = /** @type {(inputs: Event_EnterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Melden`)
};

const ru_event_enter = /** @type {(inputs: Event_EnterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Заявиться`)
};

const tr_event_enter = /** @type {(inputs: Event_EnterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kaydol`)
};

const it_event_enter = /** @type {(inputs: Event_EnterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iscriviti`)
};

const pl_event_enter = /** @type {(inputs: Event_EnterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zgłoś się`)
};

const uk_event_enter = /** @type {(inputs: Event_EnterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Заявитися`)
};

const hi_event_enter = /** @type {(inputs: Event_EnterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पंजीकरण करें`)
};

const ar_event_enter = /** @type {(inputs: Event_EnterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التسجيل`)
};

const ms_event_enter = /** @type {(inputs: Event_EnterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daftar`)
};

const bn_event_enter = /** @type {(inputs: Event_EnterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`নিবন্ধন`)
};

const zh_tw2_event_enter = /** @type {(inputs: Event_EnterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`報名`)
};

const zh_hk2_event_enter = /** @type {(inputs: Event_EnterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`報名`)
};

const ur_event_enter = /** @type {(inputs: Event_EnterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`رجسٹر کریں`)
};

const fa_event_enter = /** @type {(inputs: Event_EnterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ثبت‌نام`)
};

const sw_event_enter = /** @type {(inputs: Event_EnterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jisajili`)
};

const nl_event_enter = /** @type {(inputs: Event_EnterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inschrijven`)
};

/**
* | output |
* | --- |
* | "Enter" |
*
* @param {Event_EnterInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const event_enter = /** @type {((inputs?: Event_EnterInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_EnterInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_event_enter(inputs)
	if (locale === "ja") return ja_event_enter(inputs)
	if (locale === "zh") return zh_event_enter(inputs)
	if (locale === "es") return es_event_enter(inputs)
	if (locale === "pt") return pt_event_enter(inputs)
	if (locale === "id") return id_event_enter(inputs)
	if (locale === "fr") return fr_event_enter(inputs)
	if (locale === "tl") return tl_event_enter(inputs)
	if (locale === "vi") return vi_event_enter(inputs)
	if (locale === "ko") return ko_event_enter(inputs)
	if (locale === "de") return de_event_enter(inputs)
	if (locale === "ru") return ru_event_enter(inputs)
	if (locale === "tr") return tr_event_enter(inputs)
	if (locale === "it") return it_event_enter(inputs)
	if (locale === "pl") return pl_event_enter(inputs)
	if (locale === "uk") return uk_event_enter(inputs)
	if (locale === "hi") return hi_event_enter(inputs)
	if (locale === "ar") return ar_event_enter(inputs)
	if (locale === "ms") return ms_event_enter(inputs)
	if (locale === "bn") return bn_event_enter(inputs)
	if (locale === "zh-TW") return zh_tw2_event_enter(inputs)
	if (locale === "zh-HK") return zh_hk2_event_enter(inputs)
	if (locale === "ur") return ur_event_enter(inputs)
	if (locale === "fa") return fa_event_enter(inputs)
	if (locale === "sw") return sw_event_enter(inputs)
	if (locale === "nl") return nl_event_enter(inputs)
	return en_event_enter(inputs)
});